import { SortableHeader } from '@/components/search/SortableHeader'
import React, { useState } from 'react'
import { Services } from '@/services/services'
import { CurrentSession } from '@/services/repository/session'
import { SearchTable, SearchTableParams } from '@/components/search/SearchTable'
import { Namespace } from './common'

type UserNamespace = Namespace & { isRelated?: boolean, canAssign: boolean }

export function RelatedUserNamespacesPopup({ services, session, userId }: {
  services: Services
  session: CurrentSession
  userId: string
  onClose: () => void
}) {
  const [error, setError] = useState<string>()
  const params: SearchTableParams<UserNamespace> = {
    fetch: async q => {
      const query = new URLSearchParams({ pageNumber: String(q.pageNumber), pageSize: String(q.pageSize), search: q.search, sortBy: q.sortBy || '', sortDirection: q.sortDirection || '' })
      const response = await services.session.fetchWithToken(`/api/communal/namespaces/foruser/${userId}/search?${query}`)
      if (!response.ok) throw new Error(session.translates.for('errors.namespace_request_failed'))
      return response.json()
    },
    pageQuery: { pageNumber: 1, pageSize: 5, search: '' },
    toolbox: () => <></>,
    defaultSortBy: 'name',
    header: (query, onSort) => <><div className='hcol' /><SortableHeader field='name' query={query} onSort={onSort}>{session.translates.for('namespace.name')}</SortableHeader></>,
    row: (row, state, setState) => {
      const disabled = row.isRelated === undefined || (!row.canAssign && !row.isRelated)
      return <>
        <div className='col icocol' role='checkbox' tabIndex={0}
          aria-label={session.translates.for('namespace.assign_namespace') + ': ' + row.name}
          aria-checked={!!row.isRelated} aria-disabled={disabled}
          title={!row.canAssign && !row.isRelated ? session.translates.for('namespace.managers_only') : undefined}
          onKeyDown={event => {
            if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); event.currentTarget.click() }
          }} onClick={async () => {
            if (disabled) return
            const original = row.isRelated
            const replace = (isRelated: boolean | undefined) => setState(previous => previous ? {
              ...previous, data: previous.data?.map(n => n.id === row.id ? { ...n, isRelated } : n)
            } : previous)
            setError(undefined); replace(undefined)
            try {
              const response = await services.session.fetchWithToken(`/api/communal/namespaces/byid/${row.id}/relations/managers/${userId}`, {
                method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ related: !original })
              })
              if (!response.ok) {
                const data = await response.json().catch(() => ({}))
                setError(session.translates.for(data.errors?._general?.message ?? 'errors.namespace_request_failed'))
                replace(original)
                return
              }
              replace(!original)
            } catch { replace(original); setError(session.translates.for('errors.namespace_request_failed')) }
          }}>
          {row.isRelated === undefined ? <div className='spinner' /> : <i className={row.isRelated ? 'svgfont-checkbox' : 'svgfont-checkbox-blank'} />}
        </div>
        <div className='col'>{row.name}</div>
      </>
    },
    translates: session.translates
  }
  return <>{error && <p className='errorMessage'>{error}</p>}<SearchTable {...params} /></>
}
